import { AgbService, ApiError, ImprintService, NavigationService, PolicyService } from "./client"

export const emailPattern = {
  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  message: "Ungültige E-Mail Adresse",
}

export const namePattern = {
  value: /^[A-Za-z\s\u00C0-\u017F]{1,30}$/,
  message: "Ungültiger Name",
}

export const getPolicy = () => {
  return {
    queryFn: async () => {
      const data = await PolicyService.readPolicy()
      return data ?? { data: null, count: 0 }
    },
    queryKey: ["settings-common", "policy"],
    staleTime: Infinity,
  }
}

export const getAGB = () => {
  return {
    queryFn: async () => {
      const data = await AgbService.readAgb()
      return data ?? { data: null, count: 0 }
    },
    queryKey: ["settings-common", "agb"],
    staleTime: Infinity,
  }
}

export const getImprint = () => {
  return {
    queryFn: async () => {
      const data = await ImprintService.readImprint()
      return data ?? { data: null, count: 0 }
    },
    queryKey: ["settings-common", "imprint"],
    staleTime: Infinity,
  }
}

export const getNavigation = () => {
  return {
    queryFn: async () => {
      const data = await NavigationService.readNavigation()
      return data ?? { data: null, count: 0 }
    },
    queryKey: ["settings-navigation", "navigation"],
  }
}

export const handleError = (err: ApiError, showToast: any) => {
  const errDetail = (err.body as any)?.detail
  let errorMessage = errDetail ||  "Etwas ist schiefgelaufen. Versuchen Sie es erneut oder kontaktieren Sie den Webseitenbetreiber"
  if (Array.isArray(errDetail) && errDetail.length > 0) {
    errorMessage = errDetail[0].msg
  }
  showToast("Fehler", errorMessage, "error")
}

export function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: "auto",
    })
}
